import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  Filter,
  SearchInput,
  Show,
  SimpleShowLayout,
  ReferenceInput,
  DateField,
  ReferenceField,
  AutocompleteInput
} from 'react-admin'

export const ActivityFilter = (props) => (
  <Filter {...props}>
    <SearchInput label='Search type' source='type' />
    <ReferenceInput
      source='userId'
      reference='user'
      allowEmpty
      filterToQuery={searchText => ({ username: {$regex: searchText, $options: 'i'} })}
    >
      <AutocompleteInput optionText='username' translateChoice={false} />
    </ReferenceInput>
    <ReferenceInput
      source='appId'
      reference='app'
      allowEmpty
      filterToQuery={searchText => ({ name: {$regex: searchText, $options: 'i'} })}
    >
      <AutocompleteInput optionText='name' translateChoice={false} />
    </ReferenceInput>
  </Filter>
)

export const ActivityShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source='id' />
      <TextField srouce='type' />
      <ReferenceField source='userId' reference='user'>
        <TextField source='username' allowEmpty />
      </ReferenceField>
      <ReferenceField source='appId' reference='app'>
        <TextField source='name' allowEmpty />
      </ReferenceField>
      <DateField source='createdAt' showTime />
      <DateField source='updatedAt' showTime />
    </SimpleShowLayout>
  </Show>
)

export const ActivityList = (props) => (
  <List {...props} filters={<ActivityFilter />}>
    <Datagrid
      rowClick='show'
    >
      <TextField srouce='type' />
      <ReferenceField source='userId' reference='user'>
        <TextField source='username' allowEmpty />
      </ReferenceField>
      <ReferenceField source='appId' reference='app'>
        <TextField source='name' allowEmpty />
      </ReferenceField>
      <DateField source='createdAt' />
      <DateField source='updatedAt' />
    </Datagrid>
  </List>
)
